import { css, CSSResult } from 'lit'
import { csFormControl } from 'elements/_shared/form.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'


export const cseRadioButton = {
  backgroundColor: css`var(--cse-radio-button-background-color, ${csFormControl.backgroundColor})`,
  backgroundColorDisabled: css`var(--cse-radio-button-background-color-disabled, ${csFormControl.backgroundColorDisabled})`,
  borderColor: css`var(--cse-radio-button-border-color, ${csFormControl.borderColor})`,
  borderColorHover: css`var(--cse-radio-button-border-color-hover, ${csFormControl.borderColorHover})`,
  color: css`var(--cse-radio-button-color, ${csFormControl.color})`,
  colorDisabled: css`var(--cse-radio-button-color-disabled, ${csFormControl.colorDisabled})`,
  fontFamily: css`var(--cse-radio-button-font-family, ${csFormControl.fontFamily})`,
  fontSize: css`var(--cse-radio-button-font-size, ${csFormControl.fontSize})`,
  outlineFocus: css`var(--cse-radio-button-outline-focus, ${csFormControl.outlineFocus})`,
  alignItems: css`var(--cse-radio-button-align-items, center)`,
  gap: css`var(--cse-radio-button-gap, ${csSpacing.spacing05})`,
  size: css`var(--cse-radio-button-size, 20px)`,

  checkedBackgroundColor: css`var(--cse-radio-button-checked-background-color, ${csFormControl.backgroundColorChecked})`,
  checkedBackgroundColorHover: css`var(--cse-radio-button-checked-background-color-hover, ${csFormControl.backgroundColorCheckedHover})`,
  checkedBorderColor: css`var(--cse-radio-button-checked-border-color, ${csFormControl.borderColorChecked})`,
  checkedBorderColorHover: css`var(--cse-radio-button-checked-border-color-hover, ${csFormControl.backgroundColorCheckedHover})`,
}

export const style: CSSResult = css`
  .cse-radio-button {
    display: flex;
    align-items: ${cseRadioButton.alignItems};
    gap: ${cseRadioButton.gap};
    position: relative;
  }

  input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: ${cseRadioButton.size};
    height: ${cseRadioButton.size};
    margin: 0;
  }

  input:focus-visible + .radio-button,
  .cse-radio-button:focus-within .radio-button {
    outline: ${cseRadioButton.outlineFocus};
    outline-offset: 2px;
  }

  .radio-button {
    align-items: center;
    background: ${cseRadioButton.backgroundColor};
    border-color: ${cseRadioButton.borderColor};
    border-radius: 50%;
    border-style: solid;
    border-width: ${csBorder.width};
    display: flex;
    height: ${cseRadioButton.size};
    justify-content: center;
    position: relative;
    width: ${cseRadioButton.size};
    min-width: ${cseRadioButton.size};
  }

  .cse-radio-button:not(.disabled) {
    cursor: pointer;
  }

  .cse-radio-button:not(.disabled) .radio-button {
    cursor: pointer;
  }

  .cse-radio-button:not(.disabled) .label {
    cursor: pointer;
  }

  .cse-radio-button:not(.disabled):hover .radio-button {
    border-color: ${cseRadioButton.borderColorHover};
  }

  .label {
    color: ${cseRadioButton.color};
    font-family: ${cseRadioButton.fontFamily};
    font-size: ${cseRadioButton.fontSize};
    user-select: none;
  }

  .cse-radio-button.checked .radio-button {
    background-color: ${cseRadioButton.checkedBackgroundColor};
    border-color: ${cseRadioButton.checkedBorderColor};
  }

  .cse-radio-button.checked:hover .radio-button {
    background-color: ${cseRadioButton.checkedBackgroundColorHover};
    border-color: ${cseRadioButton.checkedBorderColorHover};
  }

  .checkmark {
    position: absolute;
    display: inline-block;
    width: calc(${cseRadioButton.size} / 2);
    height: calc(${cseRadioButton.size} / 2);
    border-radius: 50%;
    background: ${cseRadioButton.backgroundColor};
  }

  .cse-radio-button.disabled {
    pointer-events: none;
  }

  .cse-radio-button.disabled .label {
    color: ${cseRadioButton.colorDisabled};
  }

  .cse-radio-button.disabled:not(.checked) .radio-button {
    background-color: ${cseRadioButton.backgroundColorDisabled};
  }

  .cse-radio-button.disabled.checked .radio-button {
    opacity: .35;
  }
`
